import type { ButtonHTMLAttributes, ComponentType, ReactNode, Ref } from 'react';
import { classes } from '../outils/classes';
import { Lien } from '../outils/lien';
import styles from './Bouton.module.css';

export type VarianteBouton = 'principal' | 'secondaire' | 'danger' | 'discret';

export interface ProprietesIcone {
  className?: string;
  strokeWidth?: number;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export type Icone = ComponentType<ProprietesIcone>;

export interface ProprietesBouton extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBouton;
  petit?: boolean;
  pleineLargeur?: boolean;
  icone?: Icone;
  /** Action en cours : le bouton est désactivé et annonce l'état (pas de roue animée). */
  chargement?: boolean;
  libelleChargement?: string;
  ref?: Ref<HTMLButtonElement>;
}

/** Classes d'un bouton, utilisables sur un lien qui doit en avoir l'apparence. */
export function classesBouton(variante: VarianteBouton = 'principal', options: { petit?: boolean; pleineLargeur?: boolean } = {}): string {
  return classes(styles.bouton, styles[variante], options.petit && styles.petit, options.pleineLargeur && styles.pleineLargeur);
}

export function Bouton({
  variante = 'principal',
  petit,
  pleineLargeur,
  icone: IconeBouton,
  chargement,
  libelleChargement = 'Traitement en cours',
  className,
  children,
  type = 'button',
  disabled,
  ...reste
}: ProprietesBouton) {
  return (
    <button
      type={type}
      className={classes(classesBouton(variante, { petit, pleineLargeur }), className)}
      disabled={disabled || chargement}
      aria-busy={chargement || undefined}
      {...reste}
    >
      {IconeBouton ? <IconeBouton className={styles.icone} strokeWidth={1.75} aria-hidden /> : null}
      {chargement ? libelleChargement : children}
    </button>
  );
}

export interface ProprietesLienBouton {
  href: string;
  variante?: VarianteBouton;
  petit?: boolean;
  icone?: Icone;
  children: ReactNode;
  className?: string;
}

/** Lien de navigation présenté comme un bouton. */
export function LienBouton({ href, variante = 'secondaire', petit, icone: IconeLien, children, className }: ProprietesLienBouton) {
  return (
    <Lien href={href} className={classes(classesBouton(variante, { petit }), className)}>
      {IconeLien ? <IconeLien className={styles.icone} strokeWidth={1.75} aria-hidden /> : null}
      {children}
    </Lien>
  );
}
